/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Loader from 'components/shared/loader/loader';
// UTILs
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/loading/loading_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ LOADING OVERLAY: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const LoadingOverlay = props => !props.showLoader ? null :
    (
        <div className={`loading ${sheet.classes.loading}`}>
            <Loader type={`silly`} />
        </div>
    );



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LoadingOverlay;
